import { getValidParams } from './authentication-params';

function addSearch(baseUrl: string, params: { [key: string]: string }): string {
  const url = new URL(baseUrl);

  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value);
  }

  return url.toString();
}

export default function(manifestText: string, manifestUrl?: string): string {
  let playlistUrl = manifestText
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean)
    .filter(line => line[0] !== '#')[0];

  const params = getValidParams(manifestUrl);

  if (!playlistUrl || !manifestUrl) {
    return playlistUrl;
  } else if (playlistUrl.indexOf('://') >= 0) {
    return addSearch(playlistUrl, params);
  }

  // Add leading "/" to playlistUrl if needed
  playlistUrl = playlistUrl[0] === '/' ? playlistUrl : `/${playlistUrl}`;

  // add playlist url to manifest pathname part.
  const path =
    (new URL(manifestUrl).pathname || '')
      .split('/')
      .slice(0, -1) // Remove last path component
      .join('/') + playlistUrl; // Add the playlist URL as the last path component

  // build a new url with the path created above and the manifestURl as the base.
  const fullPlaylistUrl = new URL(path, manifestUrl);
  fullPlaylistUrl.hash = '';
  return addSearch(fullPlaylistUrl.toString(), params);
}
